/**
 * Convert raw meter quantity to display units.
 * When usage is shown in minutes, raw Stripe values are in seconds.
 */
export default function formatTierQuantity(quantity: number, unit: string): number {
    if (unit === 'minutes') {
        return Math.round(quantity / 60);
    }
    return quantity;
}
